var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 24",
    style: {
      enableBackground: "new 0 0 48 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#767676;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:#036635;stroke:#036635;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:none;stroke:#036635;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,9l9-7l9,7v11c0,0.5-0.2,1-0.6,1.4C20,21.8,19.5,22,19,22H5c-0.5,0-1-0.2-1.4-0.6C3.2,21,3,20.5,3,20V9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,21v-9h6v9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27,9l9-7l9,7v11c0,0.5-0.2,1-0.6,1.4C44,21.8,43.5,22,43,22H29c-0.5,0-1-0.2-1.4-0.6C27.2,21,27,20.5,27,20V9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M32,21V11h8v10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32,21V11h8v10"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.f7380cf478278aa5bd7a5853a06f1d82.svg";
export { ForwardRef as ReactComponent };